import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Layout } from "@/components/Layout";
import { Reveal } from "@/components/Reveal";
import { ScienceSection } from "@/components/ScienceSection";
import { SCIENCE, IMAGES } from "@/content";

export default function RootedInBody() {
  return (
    <Layout page="rooted-in-the-body">
      <section className="relative min-h-[75vh] flex items-center overflow-hidden">
        <img src={IMAGES.scienceHeader} alt="Movement class" className="absolute inset-0 h-full w-full object-cover opacity-55" />
        <div className="absolute inset-0 bg-gradient-to-b from-ink-900/70 via-ink-900/45 to-ink-900" />
        <div className="relative z-10 mx-auto max-w-[1400px] w-full px-5 sm:px-8 pt-28">
          <motion.span className="label" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }}>Science</motion.span>
          <motion.h1 className="font-display font-black text-white tracking-tighter mt-5 leading-[0.92]"
            style={{ fontSize: "clamp(3rem, 10vw, 8.5rem)" }}
            initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, ease: [0.25, 1, 0.5, 1] }}>
            Rooted in<br />the Body
          </motion.h1>
          <motion.p className="text-ice/85 text-lg sm:text-xl mt-8 max-w-3xl leading-relaxed"
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.8 }}>
            {SCIENCE.intro}
          </motion.p>
        </div>
      </section>

      <section className="relative py-10 sm:py-16">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          {SCIENCE.sections.map((s, i) => <ScienceSection key={s.number} section={s} index={i} />)}
        </div>
      </section>

      {/* Closing */}
      <section className="relative py-24 sm:py-32 overflow-hidden">
        <div className="absolute inset-0 mesh-top" />
        <div className="relative mx-auto max-w-4xl px-5 sm:px-8">
          <Reveal>
            <p className="font-display text-2xl sm:text-3xl font-medium text-white leading-snug">{SCIENCE.closing}</p>
          </Reveal>
          <Reveal>
            <Link to="/classes" data-testid="science-classes-link"
              className="group inline-flex items-center gap-3 mt-12 text-xl sm:text-2xl font-bold text-cyan hover:text-white transition-colors">
              Explore the Classes <ArrowRight className="group-hover:translate-x-2 transition-transform" size={24} />
            </Link>
          </Reveal>
        </div>
      </section>
    </Layout>
  );
}
